// Func = limiting Scope for this file
(function(){
	$(document).ready(function () {
		
	});

}()); 